<!-- <app-autopay-popup
  *ngIf="showCertifiedPopup"
  style="z-index: 500"
  [type]="100"
  (closed)="onPopupClosed()"
  class="hover-content"
>
</app-autopay-popup> -->
<div [style.margin-top]="!dentistListInfo?.data?.providers?.length ? '2.5em' : 'initial'" class="dentistCards">
  <!-- <div class="dentistCards__header d-flex">
    <div style="height: 1em; margin: auto 0">
      {{ dentistListInfo?.totalCount }}&nbsp;&nbsp;|&nbsp;&nbsp;Results
    </div>
    <div class="m-l-auto d-flex">
      <div style="height: 1em; margin: auto 0.5em auto 0">
        {{ dentistListInfo?.preferdCount }}&nbsp;&nbsp;|&nbsp;&nbsp;iCreditWorks-Certified dentist
      </div>
      <img
        (click)="onPopupOpen()"
        style="height: 1.2em"
        src="../../../../../assets/images/info-payIn4.png"
        alt=""
      />
    </div>
  </div> -->
  <div
    id="dentistScroll"
    *ngIf="dentistListInfo?.data?.providers?.length"
    style="
      max-height: calc(36 * var(--sz) - 8.25em);
      overflow: auto;
      /* margin-top: 0.25em; */
      width: calc(100% + 0.5em);
    "
  >
    <div
      (click)="clickDentist(i)"
      *ngFor="let dentCard of dentistListInfo?.data.providers; let i = index"
      style="
        margin: 0 0 0.25em;
        padding: 0.25em 0;
        border: 1px solid #d9d9d9;
        min-width: 100%;
        position: relative;
      "
      [ngClass]="{dentistCard_provider: dentCard.type === 'Practice'}"
      class="dentistCard profile_section d-flex background-white border-gray-white profile_section-full_width py-regular px-big a-items-center pos-rel"
    >
      <div class="d-flex a-items-center w-100">
        <div
          class="doctor_avatar"
          [ngClass]="{
            border: dentCard?.icwPreferred === true,
            'no-border': dentCard?.icwPreferred === false
          }"
          *ngIf="dentCard?.imageUrl || dentCard.type === 'Practice'; else noDoctorImage"
        >
          <img
            [src]="
              dentCard.type !== 'Practice'
                ? dentCard?.imageUrl
                : '../../../../../assets/images/doctor-practice.webp'
            "
            alt=""
            loading="lazy"
            srcset=""
          />
        </div>
        <ng-template #noDoctorImage>
          <div
            class="doctor_avatar"
            [ngClass]="{
              border: dentCard?.icwPreferred === true,
              border_none: dentCard?.icwPreferred === false
            }"
            *ngIf="dentCard?.gender == 'M'"
          >
            <img
              src="../../../../../assets/images/m_icon_preferred_dent.webp"
              alt=""
              loading="lazy"
              srcset=""
            />
          </div>
          <div
            class="doctor_avatar"
            [ngClass]="{
              border: dentCard?.icwPreferred === true,
              border_none: dentCard?.icwPreferred === false
            }"
            *ngIf="dentCard?.gender == 'F'"
          >
            <img
              src="../../../../assets/images/f_icon_preferred_dent.webp"
              alt=""
              loading="lazy"
              srcset=""
            />
          </div>
          <div
            class="doctor_avatar"
            [ngClass]="{
              border: dentCard?.icwPreferred === true,
              border_none: dentCard?.icwPreferred === false
            }"
            *ngIf="dentCard?.gender == null || dentCard?.gender.length === 0"
          >
            <img
              src="../../../../../assets/images/doctor-empty_preferred_dent.webp"
              alt=""
              loading="lazy"
              srcset=""
            />
          </div>
        </ng-template>
        <!-- <div class="doctor_avatar border">
          <img
            style="height: 5.5em"
            class="border"
            [src]="dentCard?.imageUrl"
            alt=""
            loading="lazy"
            srcset=""
          />
        </div> -->
        <!-- <div class="doctor_avatar placeholder" [ngClass]="{'border': dentistInfo?.icwPreferred === true, 'border_none': dentistInfo?.icwPreferred === true}" *ngIf="dentistInfo?.gender == 'F'">
                    <img *ngIf="dentistInfo?.icwPreferred" src="../../../../assets/images/f_icon_prederred.svg')" alt="" loading="lazy" srcset="">
                    <img *ngIf="!dentistInfo?.icwPreferred" src="../../../../assets/images/f_icon.svg')" alt="" loading="lazy" srcset="">
                </div>
                <div class="doctor_avatar placeholder" [ngClass]="{'border': dentistInfo?.icwPreferred === true, 'border_none': dentistInfo?.icwPreferred === true}" *ngIf="dentistInfo?.gender == null || dentistInfo?.gender.length === 0">
                    <img *ngIf="dentistInfo?.icwPreferred" src="../../../../assets/images/doctor-empty_preferred.svg')" alt="" loading="lazy" srcset="">
                    <img *ngIf="!dentistInfo?.icwPreferred" src="../../../../assets/images/doctor-empty.svg')" alt="" loading="lazy" srcset="">
                </div> -->
        <div style="width: 100%" class="flex-column text-align-left">
            <!-- {{ dentistInfo ? dentistInfo?.title + ' ' + dentistInfo?.doctorName : homeData?.dentistName }} --><img
              style="height: .9em; width: fit-content; margin-bottom: 0.2em;"
              [style.opacity]="dentCard.icwPreferred ? 1 : 0"
              src="../../../../../assets/images/icw-certified.webp"
              alt=""
            />
          <div
            *ngIf="dentCard.type !== 'Practice'"
            style="font-size: 1.2em; line-height: 0.97; color: #111;"
            class="font-black font-weight-bold"
          >
            <!-- {{ dentistInfo ? dentistInfo?.title + ' ' + dentistInfo?.doctorName : homeData?.dentistName }} -->{{
              dentCard.doctorName
            }}
          </div>
          <div
            [class.font-weight-bold]="dentCard.type === 'Practice'"
            [style.font-size]="dentCard.type === 'Practice' ? '1,2em' : 'initial'"
            [style.color]="dentCard.type === 'Practice' ? '#111' : '#666'"
            style="
              width: max-content;
              max-width: 60%;
              white-space: nowrap;
              overflow: hidden;
              text-overflow: ellipsis;
              margin-bottom: 0.2em;
            "
            class="font-regular-big font-light-black text-truncate"
          >
            <!-- {{dentistInfo?.practiceName ? dentistInfo?.practiceName : '&nbsp;'}} -->{{
              dentCard.practiceName
            }}
          </div>
          <div style="font-size: .9em;" class="font-light-black d-flex">
            <img
              style="height: 1.1em"
              src="../../../../../assets/images/icons/ico-location@3x.webp"
              alt=""
            /><!-- {{ dentistInfo?.doctorsAddressInfo?.city }}, {{dentistInfo?.doctorsAddressInfo?.state}} {{dentistInfo?.doctorsAddressInfo?.zipCode}} -->
            <div style="
            margin: auto 0 auto 0.25em;
            width: max-content; color: #333333;">
              {{ dentCard.doctorsAddressInfo.city }}, {{ dentCard.doctorsAddressInfo.state }},
              {{ dentCard.doctorsAddressInfo.zipCode }}<br><span style="font-size: .9em; color: rgba(51, 51, 51, 0.5);">{{
                distance(dentCard.distance)
              }}
              miles</span>
            </div>
          </div>
          <!-- <div style="font-size: .7em;" class="font-smaller font-light-black">
            {{ dentistInfo?.doctorsAddressInfo?.city }}, {{dentistInfo?.doctorsAddressInfo?.state}} {{dentistInfo?.doctorsAddressInfo?.zipCode}}
          </div> -->
          <div *ngIf="dentCard.type !== 'Practice' && dentCard.specialityDesc" style="color: #333;" class="doctor-speciality font-smaller font-light-black">
            <!-- {{dentistInfo?.speciality.length > 0 ? dentistInfo?.speciality : '&nbsp;'}} -->{{
              dentCard.specialityDesc
            }}
          </div>
        </div>
      </div>
      <div class="absolute-right top-40">
        <div class="checkboxItem">
          <div
            class="checkboxItem__flag"
            [class.checkboxItem__flag_selected]="selectedCardNumber === i"
          ></div>
        </div>
      </div>
    </div>
  </div>
  <div
    style="background-color: white; flex-direction: column;"
    class="find-dentist-banner d-flex w-100 background-color-white"
    *ngIf="!dentistListInfo?.data?.providers?.length"
  >
    <div class="find-dentist-banner__logo">
      <img style="height: 6em; margin-top: 1em" src="../../../../../assets/images/find-dentist.webp" alt="" />
    </div>
    <div style="margin: 1em 0 0.7em" class="find-dentist-banner__text">
      <span class="font-color-black">No Dentists Match Your Search</span>
    </div>
    <div style="font-size: 0.8em" class="find-dentist-banner__text">
      Your selection could not be located<br>
      in the iCreditWorks directory.
    </div>
    <div style="font-size: 0.8em; margin: 1em auto;" class="find-dentist-banner__text">
      Adjust your search criteria or simply click <span class="font-weight-bold">continue</span>.
    </div>
  </div>
</div>
